import React from 'react';
import { Route } from 'react-router-dom';
import SalesLedgerIframe from '.';

interface Paths {
  salesLedger: string;
}

const paths: Paths = {
  salesLedger: '/reports/sales',
};

export default [
  <Route exact path={paths.salesLedger} component={SalesLedgerIframe} key={paths.salesLedger} />,
];
